export default function PD6630HowItWorksHeading() {
  return (
    <div className="flex flex-col items-center gap-2 text-center sm:mb-20">
      <p className="m-0 hidden text-base font-semibold text-ds-brand-700 sm:block">How it works</p>
      <h2 className="sr-only m-0 text-lg font-semibold tracking-tight text-ds-gray-light-950 sm:not-sr-only">
        Three steps to half-price dining
      </h2>
    </div>
  );
}
